export default theme => ({
  root: {
    width: "100%",
    marginBottom: 15
  }
});
